import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-order-failed',
  templateUrl: './order-failed.component.html',
  styleUrls: ['./order-failed.component.scss']
})
export class OrderFailedComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<OrderFailedComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any
    ) { }

  ngOnInit(): void {
  }

}
